import { useState, useRef, useEffect } from "react";
import toast from "react-hot-toast";
import { customToast } from "../components/toasts";

function useImageUpload({ initialImage = null, allowedTypes = ["image/*"], maxFileSizeMb = 5 } = {}) {
  const [previewUrl, setPreviewUrl] = useState(initialImage);
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null); // New state for errors
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (initialImage) {
      setPreviewUrl(initialImage);
    }
  }, [initialImage]);

  const handleThumbnailClick = () => {
    fileInputRef.current.click();
  };

  const handleRemove = () => {
    setPreviewUrl(null);
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const isUnderMaxSize = (file) => {
    const maxBytes = maxFileSizeMb * 1024 * 1024;
    return file.size <= maxBytes;
  };

  const loadFile = (file) => {

    const isFileTypeAllowed = allowedTypes.some(type => {
      if (type.endsWith("/*")) {
        const mainType = type.split("/")[0];
        return file.type.startsWith(mainType + "/");
      }
      return file.type === type;
    });

    const sizeValid = isUnderMaxSize(file);

    if (!isFileTypeAllowed) {
      toast((t) => customToast("Invalid File Type", "error", t), {
        duration: 3000,
        removeDelay: 1000,
        style: {
          padding: "0.75rem",
          margin: "0",
          minWidth: "200px",
          backgroundColor: "rgb(255,255,255)",
        },
      });
      // setPreviewUrl(null);
      // setFile(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
      return;
    }

    if (!sizeValid) {
      toast((t) => customToast("File Size should be less than 5MB", "error", t), {
        duration: 3000,
        removeDelay: 1000,
        style: {
          padding: "0.75rem",
          margin: "0",
          minWidth: "200px",
          backgroundColor: "rgb(255,255,255)",
        },
      });
      // setPreviewUrl(null);
      // setFile(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
      return;
    }

    setError(null);
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    setFile(file);
  };

  const handleChange = (e) => {
    const f = e.target.files[0];
    if (f) loadFile(f);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const f = e.dataTransfer.files[0];
    if (f) loadFile(f);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return { previewUrl, file, fileInputRef, handleThumbnailClick, handleRemove, handleChange, handleDrop, handleDragOver };
}

export default useImageUpload;